export default __webpack_public_path__ + "atomic/_patterns/03-organisms/ct-letters-and-statements/_ct-letters-and-statements.twig";